__turbopack_context__.v({
  "backLink": "fullScreenCalculator-module__XCN_Aq__backLink",
  "btnClear": "fullScreenCalculator-module__XCN_Aq__btnClear",
  "btnEquals": "fullScreenCalculator-module__XCN_Aq__btnEquals",
  "btnFullScreen": "fullScreenCalculator-module__XCN_Aq__btnFullScreen",
  "btnFunc": "fullScreenCalculator-module__XCN_Aq__btnFunc",
  "btnMemory": "fullScreenCalculator-module__XCN_Aq__btnMemory",
  "btnNum": "fullScreenCalculator-module__XCN_Aq__btnNum",
  "btnOp": "fullScreenCalculator-module__XCN_Aq__btnOp",
  "calcContainer": "fullScreenCalculator-module__XCN_Aq__calcContainer",
  "display": "fullScreenCalculator-module__XCN_Aq__display",
  "footer": "fullScreenCalculator-module__XCN_Aq__footer",
  "fullScreen": "fullScreenCalculator-module__XCN_Aq__fullScreen",
  "grid": "fullScreenCalculator-module__XCN_Aq__grid",
  "wrapper": "fullScreenCalculator-module__XCN_Aq__wrapper",
});
